import { reactive } from "vue";
import { api } from "~/api/Api";
import { NyukyoInfo } from "~/api/data";
import { FindNyukyoInfo } from "~/api/nyukyoInfo";
class Store {
    query = null;
    nyukyo = new NyukyoInfo();
    async load(nyukyokeiyakuNo) {
        this.query = new FindNyukyoInfo(nyukyokeiyakuNo);
        this.nyukyo = await api.nyukyoInfos.find(this.query);
    }
    clear() {
        this.nyukyo = new NyukyoInfo();
    }
}
export let store = reactive(new Store());
